(function () {
  'use strict';

  var DESKTOP_BREAKPOINT = 1024;
  // Pixel-based anchor offsets for tab-link scrolling.
  // Adjust these values (+/-) to fine tune landing position.
  var HASH_SCROLL_OFFSET_DESKTOP = 130;
  var HASH_SCROLL_OFFSET_MOBILE = 110;
  var HASH_SCROLL_OFFSET_FINE_TUNE = 0;
  var tabsBlockHost = null;
  var tabsBlockContent = null;
  var relatedProductsOriginalParent = null;
  var relatedProductsOriginalNext = null;

  function isDesktop() {
    return window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)').matches;
  }

  function moveTabsToMediaWrapper(host) {
    var content = host.firstElementChild;
    if (!content) return false;
    var target = document.querySelector('.product__media-wrapper');
    if (!target) return false;
    tabsBlockHost = host;
    tabsBlockContent = content;
    target.appendChild(content);
    attachAccordionDelegationTo(content);
    return true;
  }

  function moveTabsBackToHost() {
    if (!tabsBlockHost || !tabsBlockContent) return;
    var target = document.querySelector('.product__media-wrapper');
    if (!target || !target.contains(tabsBlockContent)) return;
    tabsBlockHost.insertBefore(tabsBlockContent, tabsBlockHost.firstChild);
    tabsBlockHost._moved = false;
    tabsBlockHost.classList.remove('tabs-block--in-place');
    attachAccordionDelegationTo(tabsBlockContent);
  }

  function appendRelatedProductsSection() {
    var slot = document.querySelector('.related-products-wrapper[data-related-products-slot]');
    var section = document.querySelector('product-recommendations.related-products');
    if (!slot || !section || section.parentNode === slot) return;
    if (!relatedProductsOriginalParent && section.parentNode) {
      relatedProductsOriginalParent = section.parentNode;
      relatedProductsOriginalNext = section.nextSibling;
    }
    slot.appendChild(section);
  }

  function moveRelatedProductsBack() {
    var section = document.querySelector('product-recommendations.related-products');
    if (!section || !relatedProductsOriginalParent) return;
    var slot = document.querySelector('.related-products-wrapper[data-related-products-slot]');
    if (!slot || !slot.contains(section)) return;
    relatedProductsOriginalParent.insertBefore(section, relatedProductsOriginalNext);
  }

  function handleAccordionClick(header) {
    var item = header.closest('.accordion-item');
    var wrapper = header.closest('.accordions-wrapper');
    if (!item || !wrapper) return;
    var isOpen = item.classList.contains('is-open');
    var siblingItems = wrapper.querySelectorAll('.accordion-item');
    siblingItems.forEach(function (s) { s.classList.remove('is-open'); });
    if (!isOpen) item.classList.add('is-open');
  }

  function attachAccordionDelegationTo(root) {
    if (!root || root._accordionDelegationAttached) return;
    root._accordionDelegationAttached = true;
    root.addEventListener('click', function (e) {
      var header = e.target.closest('.accordion-item-header');
      if (!header || !root.contains(header) || !header.closest('.accordions-wrapper')) return;
      e.preventDefault();
      e.stopPropagation();
      handleAccordionClick(header);
    }, true);
  }

  function setupAccordionDelegation() {
    if (document.body._accordionDelegationAttached) return;
    document.body._accordionDelegationAttached = true;
    document.body.addEventListener('click', function (e) {
      var header = e.target.closest('.accordion-item-header');
      if (!header || !header.closest('.accordions-wrapper')) return;
      e.preventDefault();
      e.stopPropagation();
      handleAccordionClick(header);
    }, true);
  }

  function setupDetailsBlockCollapse() {
    if (document.body._detailsBlockCollapseAttached) return;
    document.body._detailsBlockCollapseAttached = true;
    document.body.addEventListener('click', function (e) {
      var heading = e.target.closest('[data-details-block-heading]');
      if (!heading) return;
      var wrapper = heading.closest('[data-details-block]');
      if (!wrapper) return;
      wrapper.classList.toggle('is-open');
    }, true);
  }

  function setupTechnologyBlockCollapse() {
    if (document.body._technologyBlockCollapseAttached) return;
    document.body._technologyBlockCollapseAttached = true;
    document.body.addEventListener('click', function (e) {
      var heading = e.target.closest('[data-technology-block-heading]');
      if (!heading) return;
      var wrapper = heading.closest('[data-technology-block]');
      if (!wrapper) return;
      wrapper.classList.toggle('is-open');
    }, true);
  }

  function setupFabricsBlockCollapse() {
    if (document.body._fabricsBlockCollapseAttached) return;
    document.body._fabricsBlockCollapseAttached = true;
    document.body.addEventListener('click', function (e) {
      var heading = e.target.closest('[data-fabrics-block-heading]');
      if (!heading) return;
      var wrapper = heading.closest('[data-fabrics-block]');
      if (!wrapper) return;
      wrapper.classList.toggle('is-open');
    }, true);
  }

  function setupJudgeMeRevWidgCollapse() {
    if (document.body._jdgmRevWidgCollapseAttached) return;
    document.body._jdgmRevWidgCollapseAttached = true;
    document.body.addEventListener('click', function (e) {
      if (e.target.closest('.jdgm-write-rev-link, .jdgm-form-wrapper')) return;
      var heading = e.target.closest('[data-jdgm-rev-widg-toggle]');
      if (!heading) return;
      var widget = heading.closest('.jdgm-rev-widg');
      if (!widget) return;
      widget.classList.toggle('is-open');
      heading.setAttribute('aria-expanded', widget.classList.contains('is-open'));
    }, true);
  }

  var JDGM_ICON_PLUS = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M9 17a1 1 0 102 0v-6h6a1 1 0 100-2h-6V3a1 1 0 10-2 0v6H3a1 1 0 000 2h6v6z"/></svg>';
  var JDGM_ICON_MINUS = '<svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none"><path fill="currentColor" fill-rule="evenodd" d="M18 10a1 1 0 01-1 1H3a1 1 0 110-2h14a1 1 0 011 1z"/></svg>';

  function enhanceJudgeMeRevWidg(widget) {
    if (!widget || widget._jdgmCollapseEnhanced) return;
    var header = widget.querySelector('.jdgm-rev-widg__header');
    if (!header) return;
    widget._jdgmCollapseEnhanced = true;
    widget.classList.add('is-open');
    header.setAttribute('data-jdgm-rev-widg-toggle', '');
    header.setAttribute('role', 'button');
    header.setAttribute('tabindex', '0');
    header.setAttribute('aria-expanded', 'true');
    var icons = document.createElement('span');
    icons.className = 'jdgm-rev-widg__heading-icons jdgm-rev-widg__heading-icons--mobile';
    icons.setAttribute('aria-hidden', 'true');
    icons.innerHTML = '<span class="jdgm-rev-widg__heading-icon jdgm-rev-widg__heading-icon--plus">' + JDGM_ICON_PLUS + '</span><span class="jdgm-rev-widg__heading-icon jdgm-rev-widg__heading-icon--minus">' + JDGM_ICON_MINUS + '</span>';
    header.appendChild(icons);
    header.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        widget.classList.toggle('is-open');
        header.setAttribute('aria-expanded', widget.classList.contains('is-open'));
      }
    });
  }

  function runJudgeMeRevWidgEnhance() {
    var widgets = document.querySelectorAll('#judgeme_product_reviews .jdgm-rev-widg');
    for (var i = 0; i < widgets.length; i++) enhanceJudgeMeRevWidg(widgets[i]);
  }

  /** PDP tab links (#id): ensure collapsible blocks are open when navigating to their anchor */
  var COLLAPSIBLE_SELECTOR = '[data-details-block], [data-technology-block], [data-fabrics-block]';

  function findCollapsibleWrapper(el) {
    if (!el) return null;
    if (el.matches(COLLAPSIBLE_SELECTOR)) return el;
    var inner = el.querySelector(COLLAPSIBLE_SELECTOR);
    if (inner) return inner;
    return el.closest(COLLAPSIBLE_SELECTOR);
  }

  function openCollapsibleForHash(hash) {
    if (!hash || hash === '#') return;
    var id = decodeURIComponent(String(hash).replace(/^#/, ''));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;

    var wrapper = findCollapsibleWrapper(el);
    if (wrapper) {
      wrapper.classList.add('is-open');
      return;
    }

    var jdgm = el.matches('.jdgm-rev-widg') ? el : el.querySelector('.jdgm-rev-widg');
    if (jdgm) {
      jdgm.classList.add('is-open');
      var toggle = jdgm.querySelector('[data-jdgm-rev-widg-toggle]');
      if (toggle) toggle.setAttribute('aria-expanded', 'true');
    }
  }

  function getHashScrollOffset() {
    var baseOffset = isDesktop() ? HASH_SCROLL_OFFSET_DESKTOP : HASH_SCROLL_OFFSET_MOBILE;
    return Math.max(baseOffset + HASH_SCROLL_OFFSET_FINE_TUNE, 0);
  }

  function scrollToHashTarget(hash, behavior) {
    if (!hash || hash === '#') return;
    var id = decodeURIComponent(String(hash).replace(/^#/, ''));
    if (!id) return;
    var el = document.getElementById(id);
    if (!el) return;

    var target = findCollapsibleWrapper(el) || el;
    var top = window.pageYOffset + target.getBoundingClientRect().top - getHashScrollOffset();
    window.scrollTo({
      top: Math.max(top, 0),
      behavior: behavior || 'auto',
    });

    // Second pass after layout settles (accordion open/content expansion).
    setTimeout(function () {
      var latestTarget = findCollapsibleWrapper(el) || el;
      var latestTop = window.pageYOffset + latestTarget.getBoundingClientRect().top - getHashScrollOffset();
      window.scrollTo({ top: Math.max(latestTop, 0), behavior: 'auto' });
    }, 450);
  }

  function setActiveTabLinkFromHash(hash) {
    if (!hash || hash === '#') return;
    var normalized = String(hash).indexOf('#') === 0 ? hash : '#' + hash;
    document.querySelectorAll('.tabs-links-wrapper .tabs-links__link').forEach(function (a) {
      var href = a.getAttribute('href');
      if (href !== normalized && href !== hash) return;
      var list = a.closest('.tabs-links__list');
      if (!list) return;
      list.querySelectorAll('.tabs-links__item').forEach(function (li) {
        li.classList.remove('active');
      });
      var item = a.closest('.tabs-links__item');
      if (item) item.classList.add('active');
    });
  }

  function setupTabLinksHashOpen() {
    if (document.body._tabLinksHashOpenAttached) return;
    document.body._tabLinksHashOpenAttached = true;

    document.body.addEventListener(
      'click',
      function (e) {
        var a = e.target.closest('.tabs-links__link');
        if (!a || !a.closest('.tabs-links-wrapper')) return;
        var href = a.getAttribute('href');
        if (!href || href.charAt(0) !== '#') return;
        e.preventDefault();
        openCollapsibleForHash(href);
        setActiveTabLinkFromHash(href);
        if (window.history && window.history.pushState) {
          window.history.pushState({}, '', href);
        } else {
          window.location.hash = href;
        }
        scrollToHashTarget(href, 'smooth');
      },
      true
    );

    window.addEventListener('hashchange', function () {
      openCollapsibleForHash(location.hash);
      setActiveTabLinkFromHash(location.hash);
      scrollToHashTarget(location.hash, 'auto');
    });

    function runHash() {
      if (location.hash) {
        openCollapsibleForHash(location.hash);
        setActiveTabLinkFromHash(location.hash);
        scrollToHashTarget(location.hash, 'auto');
      }
    }
    runHash();
    setTimeout(runHash, 200);
    setTimeout(runHash, 600);
  }

  function syncLayout() {
    var desktop = isDesktop();
    var mediaWrapper = document.querySelector('.product__media-wrapper');
    var host = document.querySelector('product-tabs-block');

    if (desktop) {
      if (host && host.firstElementChild && mediaWrapper && !mediaWrapper.contains(host.firstElementChild)) {
        host._moved = moveTabsToMediaWrapper(host);
        if (!host._moved) {
          host.classList.add('tabs-block--in-place');
          attachAccordionDelegationTo(host);
        }
      }
    } else {
      if (tabsBlockHost && tabsBlockContent && mediaWrapper && mediaWrapper.contains(tabsBlockContent)) {
        moveTabsBackToHost();
      }
    }
    // Keep related products rendered inside the tab slot on all breakpoints.
    appendRelatedProductsSection();
  }

  customElements.define('product-tabs-block', class ProductTabsBlock extends HTMLElement {
    connectedCallback() {
      if (this._moved !== undefined) return;
      this._moved = false;
      if (isDesktop()) {
        this._moved = moveTabsToMediaWrapper(this);
        if (!this._moved) {
          this.classList.add('tabs-block--in-place');
          attachAccordionDelegationTo(this);
        }
      } else {
        attachAccordionDelegationTo(this);
      }
    }
  });

  function onReady() {
    setupAccordionDelegation();
    setupDetailsBlockCollapse();
    setupTechnologyBlockCollapse();
    setupFabricsBlockCollapse();
    setupJudgeMeRevWidgCollapse();
    runJudgeMeRevWidgEnhance();
    var reviewsRoot = document.getElementById('judgeme_product_reviews');
    if (reviewsRoot && typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function () { runJudgeMeRevWidgEnhance(); });
      observer.observe(reviewsRoot, { childList: true, subtree: true });
    }
    syncLayout();
    // Late pass in case either slot/section appears after initial render.
    setTimeout(syncLayout, 200);
    setTimeout(syncLayout, 600);
    setupTabLinksHashOpen();
    var mql = window.matchMedia('(min-width: ' + DESKTOP_BREAKPOINT + 'px)');
    if (mql.addListener) mql.addListener(syncLayout);
    if (mql.addEventListener) mql.addEventListener('change', syncLayout);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', onReady);
  } else {
    onReady();
  }
})();
